import _ from 'underscore';
import Backbone from 'backbone';

var CollectionView = Backbone.View.extend({

    ItemView: Backbone.View,

    initialize: function() {
        this.listenTo(this.model, 'reset', this.render);
        this.listenTo(this.model, 'remove', this.itemRemoved);
        this.listenTo(this.model, 'add', this.renderSubViewWithModel);
    },

    remove: function() {
        this.removeAllSubViews();
        return Backbone.View.prototype.remove.call(this);
    },

    removeAllSubViews: function() {
        this.subViews = this.subViews || {};
        _.each(this.subViews, function(subView) {
            subView.remove();
        }, this);
        this.subViews = {};
    },

    addSubView: function(subView) {
        this.subViews = this.subViews || {};
        var cid = subView.model.cid;
        this.subViews[cid] = subView;
    },

    itemRemoved: function(item) {
        this.subViews = this.subViews || {};
        var cid = item.cid;
        var subView = this.subViews[cid];
        subView && subView.remove();
        delete this.subViews[cid];
    },

    renderSubViewWithModel: function(model) {
        var subView = new this.ItemView({
            model: model
        });
        this.addSubView(subView);
        this.$el.append(subView.render().$el);
    },

    render: function() {
        this.removeAllSubViews();

        for (var i = 0; i < this.model.length; i++) {
            this.renderSubViewWithModel(this.model.at(i));
        }

        return this;
    }

});

export default CollectionView;


